import { Avatar, Box, Grid, IconButton, ListItem, ListItemAvatar, ListItemButton, ListItemText, Skeleton, TextField, Typography } from "@mui/material";
import { KeyboardDoubleArrowRight, Image } from '@mui/icons-material';
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import { router } from "../../app/router/Routes";
import { ListWithBorders } from "../../app/common/ListWithBorders";

export default observer(function NodesScreen() {

    const { nodeStore } = useStore()
    const { loadNodes, clearNodes, nodes, clearSelectedNode, loading } = nodeStore

    const [searchString, setSearchString] = useState('')
    const debouncedSearchString = useDebounce(searchString, 500)

    useEffect(() => {
        clearNodes()
        clearSelectedNode()
        return () => {
            clearNodes()
            clearSelectedNode()
        }
    }, [clearNodes, clearSelectedNode])

    useEffect(() => {
        if (debouncedSearchString.length > 3) {
            loadNodes(debouncedSearchString)
        }
    }, [debouncedSearchString, loadNodes])

    const handleListItemClick = (id: string) => {
        router.navigate(`/nodes/${id}`)
    };

    return (
        <Box height={'100%'}>
            <Grid container spacing={2}>
                <Grid item container spacing={2}>
                    <Grid item xs={4}>
                        <Typography variant="h4">Kompetenzbasis Übersicht</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField sx={{ width: '100%' }} placeholder="Suche... (mind. 4 Zeichen eingeben)" onChange={(e) => setSearchString(e.target.value)}>{searchString}</TextField>
                    </Grid>
                </Grid>
                <Grid item container xs={7}>
                    {
                        loading ?
                            <LoadingNodesSkeleton />
                            :
                            <ListWithBorders height={'calc(100vh - 250px)'} >
                                {nodes ? nodes.map((n) => {
                                    return <ListItem
                                        secondaryAction={
                                            <IconButton color='primary' edge="end" onClick={() => handleListItemClick(n.id)}>
                                                <KeyboardDoubleArrowRight />
                                            </IconButton>
                                        }
                                        key={`ListItem_${n.id}`}
                                        divider
                                    >
                                        <ListItemAvatar>
                                            <Avatar>
                                                <Image />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={`${n.title} (${n.organizationTitle})`}
                                            secondary={n.shortDescription.length > 150 ? n.shortDescription.substring(0, 140) + '...' : n.shortDescription}
                                        />
                                    </ListItem>
                                }) :
                                    <ListItem >
                                        <ListItemText primary="Keine Ergebnisse..." />
                                    </ListItem>
                                }
                            </ListWithBorders>
                    }
                </Grid>

            </Grid >
        </Box>
    );
})

//used to not fire a request to the backend at every keystroke but only after the user stopped typing
function useDebounce(value: string, delay: number) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);

    return debouncedValue;
}

function LoadingNodesSkeleton() {
    return <ListWithBorders height={'calc(100vh - 250px)'} >
        <ListItemButton >
            <Skeleton variant="circular" width={40} height={36} />
            <Skeleton sx={{ ml: 2 }} variant="rectangular" width="100%" height={32} />
        </ListItemButton>
        <ListItemButton >
            <Skeleton variant="circular" width={40} height={36} />
            <Skeleton sx={{ ml: 2 }} variant="rectangular" width="100%" height={32} />
        </ListItemButton>
        <ListItemButton >
            <Skeleton variant="circular" width={40} height={36} />
            <Skeleton sx={{ ml: 2 }} variant="rectangular" width="100%" height={32} />
        </ListItemButton>
        <ListItemButton >
            <Skeleton variant="circular" width={40} height={36} />
            <Skeleton sx={{ ml: 2 }} variant="rectangular" width="100%" height={32} />
        </ListItemButton>
    </ListWithBorders>
}